// eslint-disable-next-line @typescript-eslint/no-var-requires
export const BRAND_CONFIGURATION = require(`./${process.env.BRAND}`).default;
